export enum ColorNames {
    OBSIDIAN = 'obsidian-dark',
    OBSIDIAN_LIGHT = 'obsidian-light',
    CORAL_LEAF = 'coral-leaf',
    CORAL_GREEN = 'coral-green',
    CORAL_MOSS = 'coral-moss',
    CORAL_FOAM = 'coral-foam',
    CORAL_SKY = 'coral-sky',
    CORAL_INK = 'coral-ink',
    CORAL_LILY = 'coral-lily',
    CORAL_ROSE = 'coral-rose',
    CORAL_FIRE = 'coral-fire',
    CORAL_SUN = 'coral-sun',
    CORAL_MANGO = 'coral-mango',
    CORAL_SAND = 'coral-sand',
    CORAL_LIME = 'coral-lime',
    CORAL_CORN = 'coral-corn',
    CORAL_SPECIAL = 'coral-special',
    CORAL_INDIGO = 'coral-indigo'
}
